import posthogJs from 'posthog-js';

type Props = Record<string, unknown>;

let initialized = false;
let warned = false;

export const posthog = {
  init(): void {
    const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
    if (!key) {
      if (!warned) {
        // eslint-disable-next-line no-console
        console.warn('[observability] VITE_POSTHOG_KEY unset — PostHog disabled');
        warned = true;
      }
      return;
    }
    if (initialized) return;
    const host = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? 'https://us.i.posthog.com';
    posthogJs.init(key, {
      api_host: host,
      capture_pageview: true,
      autocapture: true,
      // Replay is explicitly out of scope per spec.
      disable_session_recording: true,
      // Don't auto-mask form text by default (we'll add masking explicitly if PII risk emerges).
      mask_all_text: false,
      person_profiles: 'identified_only',
    });
    initialized = true;
  },

  captureEvent(event: string, properties: Props = {}): void {
    if (!initialized) return;
    try {
      posthogJs.capture(event, properties);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[observability/posthog] capture failed:', err);
    }
  },

  identify(distinctId: string, properties: Props = {}): void {
    if (!initialized) return;
    try {
      posthogJs.identify(distinctId, properties);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[observability/posthog] identify failed:', err);
    }
  },

  reset(): void {
    if (!initialized) return;
    try {
      posthogJs.reset();
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('[observability/posthog] reset failed:', err);
    }
  },
};
